<div class="modal-header">
  <h4 class="modal-title" style="font-weight: bold">
    O cliente não recebeu o link em seu Celular?
  </h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-xs-12 text-modal">
      <ul>
        <li>Verifique se o número do celular foi digitado corretamente;</li>
        <li>Verifique as mensagens de SMS e veja se o link chegou;</li>
        <li>Verifique se a rede do celular está ativa e o modo avião foi desativado;</li>
        <li>Se o sinal de rede estiver fraco, peça para procurar um lugar que tenha um sinal melhor. </li>
      </ul>

      <div  class="disclaimer">
        <span>
          Se mesmo assim o cliente ainda não conseguir receber o link, aguarde
          alguns minutos e tente reenviá-lo novamente.
        </span>
      </div>
    </div>
  </div>
</div>

<div class="modal-btn">
  <button type="button" class="btn btn-full-orange" (click)="onAction()">
    OK, ENTENDI
  </button>
</div>
